import * as React from 'react'

import { Form } from 'factorial-form'
import { ContractFlowCustomFieldFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import TextArea from 'modules/core/components/Inputs/TextArea'

import { getCustomFieldKey } from 'modules/contracts/lib/customFields'

interface Props {
  form: Form
  field: ContractFlowCustomFieldFragment
}

const LongTextCustomField = ({ form, field }: Props) => {
  return (
    <TextArea
      mandatory={field.required ?? false}
      label={field.labelText}
      field={form.get(getCustomFieldKey(field))}
    />
  )
}

export default observer(LongTextCustomField)
